// 事件管理
import BaseEvent from '@/utils/base/BaseEvent';
export const eventMgr = new BaseEvent();

export default {
    data() {
        return {
            chartsCurrent: {
                event: '',
                name: '',
                title: '',
                value: '',
            },
            //地图要素hover显示参数
            hoverTips: [],
        };
    },
    created() {
        // eslint-disable-next-line no-undef
        this.echartslayer = new EchartsLayer(this.MapView.map);
        this.echartslayer.chart.setOption({
            animation: false,
            GLMap: {
                roam: true,
            },
            coordinateSystem: 'GLMap',
            geo: {
                map: 'GLMap',
                roam: true,
            },
            series: this.series,
        });
        //选择变化事件派发
        eventMgr.on('changeChartsSelect', this.changeChartsSelect);
        //方案切换事件派发
        eventMgr.on('changeChartsPlan', this.changeChartsPlan);
        //隐藏方案事件派发
        eventMgr.on('removeChartsPlan', this.removeChartsPlan);
        //注册地图鼠标事件
        this.MapView.map.on('mousemove', this.mapMouseMoveHandler);
        this.MapView.map.on('drag', this.mapDragHandler);
        //echartsLayer 鼠标事件
        this.echartslayer.chart.on('mouseover', this.onElayerMouseOver);
        this.echartslayer.chart.on('mouseout', this.onElayerMouseOut);
    },
    beforeDestroy() {
        eventMgr.off('changeChartsSelect', this.changeChartsSelect);
        eventMgr.off('changeChartsPlan', this.changeChartsPlan);
        this.MapView.map.off('Drag', this.mapDragHandler);
        this.MapView.map.off('mousemove', this.mapMouseMoveHandler);
    },
    methods: {
        //选择变化事件派发
        changeChartsSelect(evt) {
            if (this.verify(evt)) {
                //同步地图
                this.mapHoverChange(evt);
                //同步统计图
                eventMgr.fire('changeChartSelect', evt);
                //同步统计表
                eventMgr.fire('changeTableSelect', evt);
            }
        },
        //方案切换事件派发
        changeChartsPlan(evt) {
            //同步地图
            // this.mapTipChange(evt)
            //同步统计图
            eventMgr.fire('changeChartPlan', evt);
            //同步统计表
            eventMgr.fire('changeTablePlan', evt);
        },
        //隐藏方案事件派发
        removeChartsPlan(evt) {
            //同步地图
            // this.mapTipChange(evt)
            //同步统计图
            eventMgr.fire('removeChartPlan', evt);
            //同步统计表
            eventMgr.fire('removeTablePlan', evt);
        },
        /********************* 地图事件-start *********************/
        //被动触发
        mapHoverChange(evt) {
            //避免重复触发
            if (evt.eventName !== 'map' && evt.name !== undefined) {
                {
                    // this.mapTipTitle = evt.title
                    // this.mapTipValue = evt.value
                    const field = evt.title;
                    this.hoverIds.forEach(l => {
                        this.MapView.map.setFilter(l, ['==', field, evt.name]);
                    });
                    if (this.hoverIds.length > 0) {
                        const sourceId = this.MapView.map.getLayer(
                            this.hoverIds[0]
                        ).source;
                        const _features = this.MapView.map.getSource(sourceId)
                            ._data.features;
                        const features = _features.filter(
                            f => f.properties[field] === evt.name
                        );
                        if (features.length > 0) {
                            const feature = features[0];
                            const geometry = GeoGlobe.Feature.fromGeoJson(
                                feature
                            )[0].geometry;
                            const geom = new GeoGlobe.Geometry.Collection(
                                geometry
                            );
                            geom.calculateBounds();
                            this.showMapTip = true;
                            this.x = this.MapView.map.project(
                                geom.bounds.getCenter()
                            ).x;
                            this.y = this.MapView.map.project(
                                geom.bounds.getCenter()
                            ).y;
                            this.title = feature.properties[evt.title];
                            this.text =
                                evt.value +
                                ' : ' +
                                feature.properties[evt.value];
                        }
                    }
                }
            }
        },
        mapDragHandler(evt) {
            this.x = evt.originalEvent.clientX + 15;
            this.y = evt.originalEvent.clientY + 15;
        },
        //鼠标在地图上触发
        mapMouseMoveHandler(evt) {
            this.planDetail = false;
            let existLayers = this.queryRenderLayers.filter(layer => this.MapView.map.getLayer(layer))

            // this.queryRenderLayers
            const features = this.MapView.map.queryRenderedFeatures(evt.point, {
                layers: existLayers,
            });
            //显示文本框
            this.showMapTip = true;
            this.x = evt.point.x + 15 - 15;
            this.y = evt.point.y + 15 - 90;
            if (features.length && this.mapTips.length > 0) {
                if (
                    features[0].layer.id.indexOf('cluster') !== -1 &&
                    features[0].properties.cluster_id !== undefined
                ) {
                    this.clusterFeatureHover(features[0]);
                } else {
                    this.FeatureHover(features[0]);
                }
            } else {
                this.showMapTip = this.showChartTip;
                //清除高亮
                this.hoverIds.forEach(l => {
                    this.MapView.map.setFilter(l, ['==', 'hoverId', '']);
                });
            }
            eventMgr.fire('changeChartsSelect', {
                eventName: 'map',
                name: this.title,
            });
        },
        //图表专题图要素鼠标事件
        FeatureHover(feature) {
            const hoverField = 'hoverId';
            const tip = this.mapTips.find(tip => {
                return feature.source === tip.id;
            });
            if (tip !== undefined) {
                this.showMapTip = true;
                const mapTipArr = [];
                if (tip.showFileds.length != 0) {
                    tip.showFileds.map(item => {
                        const obj = {};
                        obj.title = item.alias;
                        obj.value = feature.properties[item.name];
                        mapTipArr.push(obj);
                    });
                }
                this.mapTipArr = mapTipArr;
                this.title = feature.properties[tip.title];
                this.text = tip.value + ' : ' + feature.properties[tip.value];
                if (feature.properties[hoverField]) {
                    this.hoverIds.forEach(l => {
                        this.MapView.map.setFilter(l, [
                            '==',
                            hoverField,
                            feature.properties['hoverId'],
                        ]);
                    });
                }
            } else {
                if (!this.showChartTip) {
                    this.showMapTip = false;
                }
            }
        },
        //点聚合专题要素鼠标事件
        clusterFeatureHover(feature) {
            this.showMapTip = false;
            this.MapView.map
                .getSource(feature.source)
                .getClusterLeaves(
                    feature.properties.cluster_id,
                    feature.properties.point_count,
                    null,
                    function (err, leaves) {
                        if (!err && leaves.length > 0) {
                            eventMgr.fire('updateClusterData', leaves);
                        }
                    }
                );
        },
        //地图方案提示参数修改
        mapTipChange(/* evt */) {
            // this.mapTipTitle = evt.title
            // this.mapTipValue = evt.value
        },
        /********************* 地图事件-end ***********************/

        /********************* echartsLayer事件-start *************/
        onElayerMouseOver(params) {
            this.showChartTip = true;
            if (params.data.model === 'Twos') {
                this.title = params.data.fromName + ' - ' + params.data.toName;
                this.text = params.data.key + ' : ' + params.data.value;
            }
            if (params.data.model === 'Roads') {
                this.title = params.data.show;
                this.text = params.data.key + ' : ' + params.data.value;
            }
        },
        onElayerMouseOut(/* params */) {
            this.showChartTip = false;
        },
        /********************* echartsLayer事件-end ***************/
        //避免重复触发事件
        verify(data) {
            let ver = false;
            if (
                this.chartsCurrent.event !== data.eventName ||
                this.chartsCurrent.name !== data.name ||
                this.chartsCurrent.title !== data.title ||
                this.chartsCurrent.value !== data.value
            ) {
                ver = true;
            }
            return ver;
        },
    },
};
